export default "__VITE_ASSET__Bu1r1QmC__"